// src/utils.ts
function getEnvVar(name) {
  if (typeof process === "undefined" || !process.env) {
    return void 0;
  }
  return process.env[name];
}
function parseEnvNum(env) {
  if (env === void 0 || env === "") {
    return void 0;
  }
  const num = parseFloat(env);
  return Number.isNaN(num) ? void 0 : num;
}
function parseEnvInt(env) {
  if (env === void 0 || env === "") {
    return void 0;
  }
  const num = parseInt(env, 10);
  return Number.isNaN(num) ? void 0 : num;
}
function parseEnvBool(env) {
  if (env === void 0 || env === "") {
    return void 0;
  }
  const lower = env.toLowerCase();
  if (["true", "1", "yes"].includes(lower)) {
    return true;
  }
  if (["false", "0", "no"].includes(lower)) {
    return false;
  }
  return void 0;
}
function parseRuntimeMode(env) {
  if (env === void 0 || env === "") {
    return void 0;
  }
  if (env === "production") {
    return "production";
  }
  if (env === "test") {
    return "test";
  }
  return "development";
}
function port(defaultPort) {
  const offset = parseEnvInt(getEnvVar("PORT_OFFSET")) ?? 0;
  return defaultPort + offset;
}

// src/environment.ts
var runtime = {
  /** The deployment environment/stage (`DEPLOY_ENV`), preferring a host-supplied override. */
  get environment() {
    return currentRuntimeConfig?.environment ?? getEnvVar("DEPLOY_ENV") ?? (false ? void 0 : "uat") ?? "development";
  },
  /** Whether the deployment environment is production. */
  get isProduction() {
    return this.environment === "production";
  },
  /** Whether the deployment environment is production-like (production or UAT). */
  get isProductionLike() {
    return this.environment === "production" || this.environment === "uat";
  },
  /** Whether the environment is local dev mode, i.e. `yarn dev`. */
  get isLocalDevMode() {
    return this.environment === "development";
  },
  /** Whether the environment is running in a local dev mode, that is `isLocalDevMode` or SST dev mode. */
  get isLocal() {
    return this.isLocalDevMode || isSstDevMode;
  },
  /** Whether debug information should be outputted (`DEBUG_ENABLE`), preferring a host-supplied override. */
  get debugEnabled() {
    return currentRuntimeConfig?.debugEnabled ?? parseEnvBool(getEnvVar("DEBUG_ENABLE")) ?? parseEnvBool(typeof STATIC_DEBUG_ENABLE === "undefined" ? void 0 : STATIC_DEBUG_ENABLE) ?? this.isLocal;
  },
  /** The default logging level (`LOG_LEVEL`), preferring a host-supplied override. */
  get logLevel() {
    return currentRuntimeConfig?.logLevel ?? getEnvVar("LOG_LEVEL") ?? (typeof STATIC_LOG_LEVEL === "undefined" ? void 0 : STATIC_LOG_LEVEL) ?? "info";
  }
};
var runtimeMode = parseRuntimeMode(getEnvVar("NODE_ENV")) ?? parseRuntimeMode(import.meta?.env?.MODE) ?? parseRuntimeMode(false ? void 0 : "production") ?? "development";
var isSstDevMode = parseEnvBool(getEnvVar("SST_DEV")) || false;
var currentRuntimeConfig = null;
function applyRuntimeConfig(config) {
  currentRuntimeConfig = config;
}
var environment = runtime.environment;
var isProduction = runtime.isProduction;
var isProductionLike = runtime.isProductionLike;
var isLocalDevMode = runtime.isLocalDevMode;
var isLocal = runtime.isLocal;
var logLevel = runtime.logLevel;
var debugEnabled = runtime.debugEnabled;
function envResource(envVarName, resource) {
  if (isLocalDevMode) {
    return getEnvVar(envVarName);
  }
  return resource();
}

export {
  getEnvVar,
  parseEnvNum,
  parseEnvInt,
  parseEnvBool,
  parseRuntimeMode,
  port,
  runtime,
  runtimeMode,
  isSstDevMode,
  applyRuntimeConfig,
  environment,
  isProduction,
  isProductionLike,
  isLocalDevMode,
  isLocal,
  logLevel,
  debugEnabled,
  envResource
};
//# sourceMappingURL=chunk-33FKEMJY.js.map